import { apiClient } from '../utils/apiClient';

export const followUser = async (userId: string): Promise<boolean> => {
    const response = await apiClient(`/users/${userId}/follow`, {
        method: 'POST',
    });
    return response.ok;
};

export const unfollowUser = async (userId: string): Promise<boolean> => {
    const response = await apiClient(`/users/${userId}/follow`, {
        method: 'DELETE',
    });
    return response.ok;
};

export interface FollowerInfo {
    count: number;
    isFollowing: boolean;
    isFollowingYou: boolean;
}

export const getFollowerCount = async (userId: string): Promise<FollowerInfo> => {
    const response = await apiClient(`/users/${userId}/followers`);
    if (!response.ok) return { count: 0, isFollowing: false, isFollowingYou: false };
    return response.json();
};
